import defaultRenderEmpty from './renderEmpty';

export var ConfigConsumerProps = {
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return 'ant-' + suffixCls;
  },
  renderEmpty: defaultRenderEmpty
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/config-provider/configConsumerProps.js
// module id = 7
// module chunks = 0